<div class="circle-loader" [ngClass]="{ 'load-complete': completed }">
    <div class="checkmark draw"></div>
</div>